import WOW from 'wowjs';

export default function () {
  new WOW.WOW(
    {
      offset:       200,          // distance to the element when triggering the animation (default is 0)
      mobile:       true,       // trigger animations on mobile devices (default is true)
      live:         false       // act on asynchronously loaded content (default is true)
    }
  ).init();
}


// WEBPACK FOOTER //
// ./js/modules/homepage-animation.js